import React, { Component, Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Slide from '../components/Slide';
import SlickSlider from 'react-slick';
import isWindow from 'components/common/helpers/isWindow';
import ReservationItem from './ReservationItem';
import NoResults from '../NoResults';
import { connect } from 'react-redux';
import { setUserLogout } from 'components/actions/authActions';
import {
  setDashboardReservations,
  setReservationToReview
} from 'components/actions/serviceActions';
import T from 'components/common/translations/Translate';
import * as STATUES from 'components/common/constants/reservationStatusConstants';
import includes from 'lodash/includes';

function SamplePrevArrow(props) {
  const { className, onClick } = props;
  return (
    <a href="" className={className} onClick={onClick}>
      <FontAwesomeIcon
        icon={['fas', 'angle-left']}
        size="lg"
      />
      <span><T>content.common.previous</T></span>
    </a>
  );
}

function SampleNextArrow(props) {
  const { className, onClick } = props;
  return (
    <a href="" className={className} onClick={onClick}>
      <FontAwesomeIcon
        icon={['fas', 'angle-right']}
        size="lg"
      />
      <span><T>content.common.next</T></span>
    </a>
  );
}

class Slider extends Component {

  componentDidMount() {
    window.FontAwesomeConfig = {
      searchPseudoElements: true
    };
    this.findAndOpenRateForm();
    var index = this.findIndexActiveReservation();
    if (index) {
      this.sliderRef.slickGoTo(index, true);
    }
  }

  findIndexActiveReservation = () => {
    var activeStatues = [
      STATUES.STATUS_NEW,
      STATUES.STATUS_ACCEPT,
      STATUES.STATUS_ASSIGNED
    ];
    for (var i = 0; i < this.props.reservations.length; i++) {
      var reservation = this.props.reservations[i];
      if (includes(activeStatues, reservation.status)) {
        return i;
      }
    }
    return null;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.reservations.length !== this.props.reservations.length) {
      this.findAndOpenRateForm();
    }
  }

  findAndOpenRateForm = () => {
    for (var i = 0; i < this.props.reservations.length; i++) {
      var reservation = this.props.reservations[i];
      if (reservation.status === STATUES.STATUS_COMPLETED &&
        reservation.hide_rate_form !== true) {
        this.props.setReservationToReview(reservation);
        return;
      }
    }
  }

  sliderSettings = () => {
    return {
      className: 'center',
      dots: false,
      infinite: false,
      speed: 500,
      centerPadding: '200px',
      centerMode: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      initialSlide: 0,
      infinite: true,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      responsive: [
        {
          breakpoint: 2000,
          settings: {
            centerPadding: '380px',
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
          }
        },
        {
          breakpoint: 1366,
          settings: {
            centerPadding: '180px',
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
          }
        },
        {
          breakpoint: 960,
          settings: {
            centerPadding: '40px',
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
          }
        },
        {
          breakpoint: 640,
          settings: {
            centerPadding: '10px',
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
          }
        }
      ]
    };
  }

  render() {
    if (!isWindow) return null;
    if (this.props.reservations.length === 0) {
      return (
        <NoResults />
      );
    }

    return (
      <div className="content">
        <p className="trip-status"><T>content.dashboard.upcoming</T></p>
        <SlickSlider
          ref={s => this.sliderRef = s}
          {...this.sliderSettings()}
        >
          {
            this.props.reservations.map(
              (r, index) => <ReservationItem key={index} reservation={r} />
            )
          }
        </SlickSlider>
        <Slide />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLogged: state.app.isLogged,
    reservations: state.service.dashboardReservations
  }
}

export default connect(
  mapStateToProps,
  { setDashboardReservations, setUserLogout, setReservationToReview }
)(Slider);
